import services from "./base";
import axios from "axios";


export const login = async (email, password) => {
  try {
    const response = await axios.post(services.urlAuth, { email, password });
    const { token } = response.data;

    if (token) {
      localStorage.setItem("token", token); // Guardar token en localStorage
      return { success: true };
    }
  } catch (error) {
    return { success: false, message: error.response?.data?.error || "Error al iniciar sesión" };
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};

export const isAuthenticated = () => !!localStorage.getItem("token");
